import * as yup from 'yup';

/**
 * Schema de validación para código de verificación de 6 dígitos
 * Valida que el código sea numérico y tenga exactamente 6 dígitos
 */
export const VerificationCodeSchema = yup.object().shape({
    code: yup
        .string()
        .required()
        .matches(/^\d{6}$/, 'Code must be exactly 6 digits')
        .length(6)
});

/**
 * Valida si un código de verificación tiene el formato correcto
 * @param {string} code - Código de 6 dígitos a validar
 * @returns {Promise<boolean>} - true si es válido, false si no lo es
 */
export const validateCodeFormat = async (code) => {
    try {
        await VerificationCodeSchema.validate({ code });
        return true;
    } catch (error) {
        return false;
    }
};

/**
 * Valida si un código de verificación tiene el formato correcto (versión síncrona)
 * @param {string} code - Código de 6 dígitos a validar
 * @returns {boolean} - true si es válido, false si no lo es
 */
export const isValidCodeFormat = (code) => {
    return /^\d{6}$/.test(code);
};
